import {
  createWelcomeDelivery1ScreenModel,
  type WelcomeDelivery1Props,
} from './WelcomeDelivery1ModelScreen';
import { WelcomeDelivery1Controller } from './WelcomeDelivery1Controller';
import { WelcomeDelivery1View } from './WelcomeDelivery1View';

export type { WelcomeDelivery1Props } from './WelcomeDelivery1ModelScreen';

export function WelcomeDelivery1(props: WelcomeDelivery1Props = {}) {
  const model = createWelcomeDelivery1ScreenModel(props);
  const controller = new WelcomeDelivery1Controller(model);

  return <WelcomeDelivery1View model={model} controller={controller} />;
}
